import React, { useState } from "react";
import { useAuth } from "../AuthProvider";

export default function AdminSpecialMonitoringPanel() {
  const { token } = useAuth() || {};
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [res, setRes] = useState(null);
  const [err, setErr] = useState(null);

  const upload = async () => {
    setErr(null);
    setRes(null);

    if (!file) {
      setErr("Pilih file Excel (.xlsx) dulu.");
      return;
    }

    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);

      const headers = {};
      if (token) headers["Authorization"] = `Bearer ${token}`;

      const r = await fetch("/api/admin/special-monitoring/import-excel", {
        method: "POST",
        headers,
        body: fd,
      });

      const js = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(js?.detail || "Upload gagal");

      setRes(js);
    } catch (e) {
      setErr(String(e.message || e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-2">
      <div className="text-xs text-gray-400 leading-relaxed">
        Saham dalam daftar <b>Pemantauan Khusus BEI</b> akan <b>di-skip</b>: tidak tarik data bandar dan tidak ada analisa BUY/SELL.
      </div>

      {/* File picker */}
      <input
        type="file"
        accept=".xlsx"
        onChange={(e) => setFile(e.target.files?.[0] || null)}
        className="w-full text-xs text-gray-200
                   file:mr-3 file:px-3 file:py-2 file:rounded-lg
                   file:border-0 file:bg-gray-800 file:text-gray-200
                   hover:file:bg-gray-700"
      />

      {/* Upload button */}
      <button
        onClick={upload}
        disabled={loading || !file}
        className={`w-full py-2 px-3 rounded-lg text-sm font-medium
          ${loading || !file ? "bg-gray-700 text-gray-400" : "bg-amber-600 hover:bg-amber-500 text-white"}`}
      >
        {loading ? "Importing..." : "⚠ Import Pemantauan Khusus (.xlsx)"}
      </button>

      {/* Result */}
      {err && (
        <div className="text-xs text-rose-300 border border-rose-500/30 bg-rose-500/10 p-2 rounded-lg">
          {err}
        </div>
      )}

      {res && (
        <div className="text-xs text-emerald-200 border border-emerald-500/30 bg-emerald-500/10 p-2 rounded-lg">
          <div><b>OK</b> ✅</div>
          <div>Imported: <b>{res.imported}</b></div>
          <div>Skipped: <b>{res.skipped}</b></div>
          <div className="text-gray-200 mt-1">{res.note}</div>
        </div>
      )}
    </div>
  );
}
